enum TaskAddonPaymentAmountType {
    TASK_ADDON = 'task_addon',
    MANUAL_AMOUNT = 'manual_amount',
    STRIPE_INVOICE = 'stripe_invoice',
}

export default TaskAddonPaymentAmountType;
